import { WorkflowTasksViewFilterArea } from "#src/batteries-included-components/FilterAreas/WorkflowTasksFilterAreas";
import {
  WorkflowTasksTablePanel,
  WorkflowTasksTablePanelProps,
} from "#src/batteries-included-components/Panels/TablePanels/WorkflowTasksTablePanel";
import { Assets } from "@validereinc/domain-controllers";
import React from "react";

const { AssetTypeSelection } = Assets.view;

type WorkflowTasksListLayoutProps = {
  tablePanelProps: WorkflowTasksTablePanelProps;
  isDisplayingMyTasks?: boolean;
};

export const WorkflowTasksListLayout = ({
  tablePanelProps,
  isDisplayingMyTasks,
}: WorkflowTasksListLayoutProps) => {
  return (
    <>
      <WorkflowTasksViewFilterArea
        key={tablePanelProps?.viewConfigStorageKey}
        viewConfigStorageKey={tablePanelProps?.viewConfigStorageKey}
        showAssigneeFilter={!isDisplayingMyTasks}
        defaultAssetType={AssetTypeSelection.ALL_ASSETS}
      />
      <WorkflowTasksTablePanel
        {...tablePanelProps}
        isDisplayingMyTasks={!!isDisplayingMyTasks}
        tableStateStorageKey={tablePanelProps?.tableStateStorageKey}
        defaultAssetType={AssetTypeSelection.ALL_ASSETS}
        disableTaskNavigation
      />
    </>
  );
};
